export const _SET_CREDIT_CODE_VALUE = "setCreditCodeValue"

export default {
  [_SET_CREDIT_CODE_VALUE](state: CreditCode, creditCodeValue: number) {
    state.creditCodeValue = creditCodeValue
  }
}
